module.exports = __webpack_public_path__ + "static/media/Eterno Modular Sofa Console_Sand.c25c3e5d.png";